import React, { useContext } from "react";
import { Col, Container, Row, Card} from "reactstrap";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import HistoryContext from "../../../Components/Hooks/HistoryContext";
import { getInspectionById } from "../../Inspection/services/inspectionsApi";
import BreadCrumb from "../../../Components/Common/BreadCrumb/BreadCrumb";
import InspectionItem from "./inspectionItem";
import VehInspection from "./vehInspection";
import VehiclePosition from "../../Vehicules/component/vehiclePosition";
import { getUserById } from "../../Users/services/userApi";
const DetailInspection = () => {

  const history = useContext(HistoryContext);
  const { id } = useParams();

  document.title = `Détails Inspections | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

  const { data: inspection = [], isLoading: isLoadingInsp, isError: isErrorInsp, error: errorInsp } = useQuery(
    ['inspection', id],
    () => getInspectionById(id)
  );

  const userId = inspection?.vehicle?.actualUserId;
  const { data: user = [], isLoading: isLoadingUser } = useQuery(
    ['user', userId],
    () => getUserById(userId),
    { enabled: !!userId }
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb page="Détail inspections" history={history} />
          <Card>
            <Row>
              <Col lg={12}>
                <VehInspection user={user} vehicle={inspection?.vehicle}/>
              </Col>
              <Col lg={8}>
                <InspectionItem inspection={inspection} isLoading={isLoadingInsp} isError={isErrorInsp} error={errorInsp}/>
              </Col>
              <Col lg={4}>
                <VehiclePosition user={user}/>
              </Col>
            </Row>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default DetailInspection;
